import './global_functions/globals';

import { ILiferay, IAUI } from './interfaces/liferay';

import { initLiveReload } from './page_logic/live_reload';
import { initHeader } from './layout_elements/header';
import { initSidebar } from './layout_elements/sidebar';
import { initSearch } from './layout_elements/search';
import { initMobileNav } from './layout_elements/mobile_nav';
import { initPortal } from './portal';
import { initContact } from './contact';
import { initChat } from './chat';
import { initLoadPresentModules } from './page_logic/module_loader';
import { initShareButtons } from './layout_elements/share_buttons';
import { initInterestRates } from './page_logic/interest_rates';
import { IFunctions, IOptions, AUIreadyFunctions, PortletsReadyFunctions } from './interfaces/initOptions';
import { initPolyfills } from './global_functions/polyfills';
import { initDisclaimer } from './layout_elements/disclaimer';

declare const AUI: IAUI;
declare const Liferay: ILiferay;

const functions: IFunctions = {
  documentReady: [initLiveReload, initPolyfills, initDisclaimer],
  auiReady: [
    { name: AUIreadyFunctions.initHeader, func: initHeader },
    { name: AUIreadyFunctions.initSearch, func: initSearch },
    { name: AUIreadyFunctions.initSidebar, func: initSidebar },
    { name: AUIreadyFunctions.initMobileNav, func: initMobileNav },
    { name: AUIreadyFunctions.initPortal, func: initPortal },
    { name: AUIreadyFunctions.initContact, func: initContact },
    { name: AUIreadyFunctions.initChat, func: initChat },
    { name: AUIreadyFunctions.initLoadPresentModules, func: initLoadPresentModules },
  ],
  allPortletsReady: [
    { name: PortletsReadyFunctions.initShareButtons, func: initShareButtons },
    { name: PortletsReadyFunctions.initInterestRates, func: initInterestRates },
  ],
};

export const init = (options?: IOptions): void => {
  let filteredAUIReadyFunctions = functions.auiReady;
  let filteredPortletsReadyFunctions = functions.allPortletsReady;

  if (options) {
    if (options.auiReady?.disabledFunctions?.length > 0) {
      const disabledFunctions = options.auiReady.disabledFunctions;
      filteredAUIReadyFunctions = filteredAUIReadyFunctions.filter(func => !disabledFunctions.includes(func.name));
    }

    if (options.allPortletsReady?.disabledFunctions?.length > 0) {
      const disabledFunctions = options.allPortletsReady.disabledFunctions;
      filteredPortletsReadyFunctions = filteredPortletsReadyFunctions.filter(
        func => !disabledFunctions.includes(func.name),
      );
    }

    if (options.auiReady) {
      filteredAUIReadyFunctions.forEach(fFunc => {
        const { name } = fFunc;
        if (options.auiReady.before?.length > 0) {
          const injectBefore = options.auiReady.before.find(oFunc => oFunc.name === name);
          if (injectBefore) {
            fFunc.before = injectBefore.functions;
          }
        }
        if (options.auiReady.after?.length > 0) {
          const injectAfter = options.auiReady.after.find(oFunc => oFunc.name === name);
          if (injectAfter) {
            fFunc.after = injectAfter.functions;
          }
        }
      });
    }

    if (options.allPortletsReady) {
      filteredPortletsReadyFunctions.forEach(fFunc => {
        const { name } = fFunc;
        if (options.allPortletsReady.before?.length > 0) {
          const injectBefore = options.allPortletsReady.before.find(oFunc => oFunc.name === name);
          if (injectBefore) {
            fFunc.before = injectBefore.functions;
          }
        }
        if (options.allPortletsReady.after?.length > 0) {
          const injectAfter = options.allPortletsReady.after.find(oFunc => oFunc.name === name);
          if (injectAfter) {
            fFunc.after = injectAfter.functions;
          }
        }
      });
    }
  }

  jQuery(() => {
    functions.documentReady.forEach(func => func.call(this));
    options?.documentOnReady?.forEach(func => {
      func.call(this);
    });
  });

  AUI().ready(() => {
    filteredAUIReadyFunctions.forEach(func => {
      func.before?.forEach(bFunc => bFunc.call(this));
      func.func.call(this);
      func.after?.forEach(aFunc => aFunc.call(this));
    });
    options?.auiReady?.afterAll?.forEach(oFunc => oFunc.call(this));
  });

  Liferay.on('allPortletsReady', () => {
    filteredPortletsReadyFunctions.forEach(func => {
      func.before?.forEach(bFunc => bFunc.call(this));
      func.func.call(this);
      func.after?.forEach(aFunc => aFunc.call(this));
    });
    options?.allPortletsReady?.afterAll?.forEach(oFunc => oFunc.call(this));
  });
};
